export default __webpack_public_path__ + "static/media/cycloneofsteel9.a1ff77c4.png";